// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"BeforeAfterModule_cardContainer__2ZNTg","cardHeader":"BeforeAfterModule_cardHeader__22NGi"};